var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.456,
    height: 17.456,
    viewBox: "0 0 17.456 17.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M6.864,5.426h5.479v1.3H6.864v5.613h-1.5V6.731H0v-1.3H5.368V0h1.5Z",
    transform: "translate(8.728) rotate(45)",
    fill: "#727275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearTextIcon);
export default __webpack_public_path__ + "static/media/clearTextIcon.c002dabadb34d48ffa60d9cca2bdddd2.svg";
export { ForwardRef as ReactComponent };